import { rentDuckApi } from "api/rentDuck";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { Layout } from "providers/Layout";
import { useAuthContext } from "providers/Auth";
import { IntegrationId } from "views/settings-integration/components/AddIntegrationModal/types";
import { FeedAutoAddCard } from "views/settings-integration/integrations/shared/FeedAutoAddCard";
import { FeedListingsCard } from "views/settings-integration/integrations/shared/FeedListingsCard";
import { IntegrationDetailHeader } from "views/settings-integration/integrations/shared/IntegrationDetailHeader";
import { toast } from "react-toastify";
import { getErrorMessage } from "utils/error";

export const RentDuckView = () => {
  const navigate = useNavigate();
  const { refreshPartnerData } = useAuthContext();

  const { mutate: disconnectRentDuck, isPending: isDisconnecting } =
    useMutation({
      mutationKey: ["RENT_DUCK", "DELETE"],
      mutationFn: () => rentDuckApi.disconnect(),
      onSuccess: () => {
        toast.success("Rent Duck integration disconnected successfully");
        refreshPartnerData();
        navigate("/settings/integration");
      },
      onError: (err) => {
        toast.error(getErrorMessage(err));
      }
    });

  return (
    <Layout
      header={
        <IntegrationDetailHeader
          id={IntegrationId.RENT_DUCK}
          name="Rent Duck"
          path="/settings/integration/rent-duck"
          onDisconnect={() => disconnectRentDuck()}
          isDisconnecting={isDisconnecting}
        />
      }
    >
      <div className="space-y-6">
        <FeedAutoAddCard feed="rent_duck" feedLabel="Rent Duck" />
        <FeedListingsCard feed="rent_duck" feedLabel="Rent Duck" />
      </div>
    </Layout>
  );
};
